import { useStore } from '@nanostores/react';
import { Arrow, Content } from '@radix-ui/react-dropdown-menu';
import { motion } from 'framer-motion';
import { memo, type ComponentProps } from 'react';
import { TitleControls } from './TitleControls.client';
import { descriptionStore } from '~/lib/stores/description';
import { projectStore } from '~/lib/stores/project';
import { dropdownAnimationVariants } from '~/utils/animationVariants';

interface ProjectSettingsDropdownContentProps {
  align?: ComponentProps<typeof Content>['align'];
  onTitleChange: (newTitle: string) => void;
}

export const ProjectRenameDropdownContent = memo(
  ({ align = 'center', onTitleChange }: ProjectSettingsDropdownContentProps) => {
    const description = useStore(descriptionStore);
    const permissions = useStore(projectStore.permissions);

    if (!permissions.canRename) {
      return <span className="max-w-96 text-xs truncate">{description}</span>;
    }

    return (
      <Content
        className="z-visibility-dropdown"
        onCloseAutoFocus={(event) => event.preventDefault()}
        asChild
        forceMount
        avoidCollisions={false}
        sideOffset={3}
        align={align}
      >
        <motion.div initial="close" animate="open" exit="close" variants={dropdownAnimationVariants}>
          <div className="flex flex-col gap-4 bg-bolt-elements-background-depth-1 dark:bg-bolt-elements-background-depth-2 px-3 pt-2 pb-3 border border-bolt-elements-borderColor shadow-lg rounded-md text-sm select-none min-w-[325px]">
            <TitleControls onTitleChange={onTitleChange} />

            <Arrow className="fill-bolt-elements-borderColor" />
          </div>
        </motion.div>
      </Content>
    );
  },
);
